module.exports = __webpack_public_path__ + "img/logo.606dc7ab.png";